import { Button, Modal, Typography } from "antd";
import React, { useState } from "react";
import "./LinkUploadModal.css";
import Input from "../../Input/Input";
import { useDispatch } from "react-redux";
import { updateCountGeneratedModels } from "../../../service/apiSlices/staticApi";
import { useLinkUploadMutation } from "../../../service/apiSlices/dashboard";
import { useTranslation } from "react-i18next";
import { showErrorToast, showSuccessToast } from "../../../utilities/toastUtils";
import { useModalContainer } from "../../../utilities/Models/modelUtils";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../utilities/Constants/Constants";

const   LinkUploadModal = ({ type, isModalOpen, setIsModalOpen }: { type: string, isModalOpen: boolean, setIsModalOpen: () => void }) => {
  const { t } = useTranslation("common");
  const [link, setLink] = useState("");
  const [uploadLink] = useLinkUploadMutation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const modalContainer = useModalContainer();

  const handleOnClose = () => {
    setIsModalOpen();
  };

  const handleOnSubmit = async () => {
    const params = { weblink: encodeURIComponent(link) };
    if (link) {
      uploadLink(params).unwrap().then((response) => {
        if (response.status_code === 200) {
          showSuccessToast(response.message);
          setLink("");
          handleOnClose();
          dispatch(updateCountGeneratedModels());
        } else {
          showErrorToast(response?.message)
        }
        // onSubmit(link);
      })
    } else {
      showErrorToast("The URL field should not empty")
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleOnSubmit();
    }
  };

  return (
    <>
      <p
        className="card-link ps-0"
      >
        {t('uploadOptions.uploadWebLink.title')}
      </p>
      <Modal
        title={false}
        footer={false}
        centered
        open={isModalOpen}
        onCancel={(e: any) => { handleOnClose(); e.stopPropagation(); setLink("") }}
        className="link-upload-modal"
        width={450}
        mask={false}
        getContainer={() => modalContainer || document.body}
      >
        <Typography.Title className="modal-title mb-3">{t('uploadOptions.uploadWebLink.modalTitle')}</Typography.Title>
        <Typography.Paragraph
          ellipsis={{ rows: 3 }}
          className="modal-description"
        >
          {t('uploadOptions.uploadWebLink.modalDescription')}
        </Typography.Paragraph>

        <h6 className="paste-link-heading">{t('pasteLink')}</h6>
        <div className="d-flex justify-content-between align-items-center gap-1">
          <Input
            placeholder={t('enterURL')}
            className="custom-input url-custom-input w-100"
            value={link}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setLink(e.target.value)
            }
            onKeyDown={handleKeyPress}
          />
          <Button onClick={handleOnSubmit} className="linkModel-button">
            {t('buttons.enter')}
          </Button>
        </div>
        <div className="d-flex justify-content-end">
          < Button
            style={{ width: "120px" }}
            className="viewModel-btn mt-2"
            onClick={() => navigate(ROUTES.VIEWMODELS)}
          >
            {t("buttons.viewModel")}
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default LinkUploadModal;
